<template>
  <div class="form-step">
    <!-- Students Supervised Section -->
    <div class="section-header d-flex justify-content-between align-items-center">
      <h5 class="section-title">Students Supervised</h5>
      <button type="button" class="btn btn-outline-primary" @click="addStudent">
        <i class="bi bi-plus me-2"></i>Add Students Supervised
      </button>
    </div>

    <div v-for="(student, index) in studentsSupervised" :key="`student-${studentKey(student, index)}`" class="student-item mb-4 p-3 border rounded">
      <div
        class="student-header d-flex justify-content-between align-items-center"
        role="button"
        tabindex="0"
        @click="toggleStudent(studentKey(student, index))"
        @keydown.enter.prevent="toggleStudent(studentKey(student, index))"
        @keydown.space.prevent="toggleStudent(studentKey(student, index))"
      >
        <h6 class="mb-0 border-0 pb-0">{{ studentHeaderTitles[studentKey(student, index)] }}</h6>
        <i class="bi" :class="isStudentExpanded(studentKey(student, index)) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </div>
      <div v-if="isStudentExpanded(studentKey(student, index))" class="row my-3">
        <div class="col-md-4">
          <label class="form-label">Type</label>
          <input
            type="text"
            class="form-control"
            v-model="student.type"
            @input="emitUpdate"
          >
        </div>
        <div class="col-md-4">
          <label class="form-label">Name</label>
          <input
            type="text"
            class="form-control"
            v-model="student.name"
            @input="emitUpdate"
          >
        </div>
        <div class="col-md-4">
          <label class="form-label">Title</label>
          <select
            class="form-select"
            v-model="student.title"
            @change="emitUpdate"
          >
            <option value="">Select Title</option>
            <option value="Mr">Mr</option>
            <option value="Mrs">Mrs</option>
            <option value="Miss">Miss</option>
            <option value="Ms">Ms</option>
            <option value="Dr">Dr</option>
            <option value="Associate Professor">Associate Professor</option>
            <option value="Professor">Professor</option>
            <option value="Public">Public</option>
          </select>
        </div>
      </div>
      <div v-if="isStudentExpanded(studentKey(student, index))" class="row mb-3">
        <div class="col-md-4">
          <label class="form-label">University</label>
          <input
            type="text"
            class="form-control"
            v-model="student.university"
            @input="emitUpdate"
          >
        </div>
        <div class="col-md-4">
          <label class="form-label">Start date</label>
          <input
            type="date"
            class="form-control"
            v-model="student.startDate"
            @input="emitUpdate"
          >
        </div>
        <div class="col-md-4">
          <label class="form-label">End date</label>
          <input
            type="date"
            class="form-control"
            v-model="student.endDate"
            @input="emitUpdate"
          >
        </div>
      </div>
      <div v-if="isStudentExpanded(studentKey(student, index))" class="row">
        <div class="col-md-12 d-flex justify-content-end">
          <button type="button" class="btn btn-sm btn-outline-danger" @click="removeStudent(index)">
            <i class="bi bi-x me-1"></i>Remove
          </button>
        </div>
      </div>
    </div>

    <!-- Awards Section -->
    <div class="section-header d-flex justify-content-between align-items-center">
      <h5 class="section-title">Awards received since completing EDCTP Fellowship</h5>
      <button type="button" class="btn btn-outline-primary" @click="addAward">
        <i class="bi bi-plus me-2"></i>Add Award
      </button>
    </div>

    <div v-for="(award, index) in awards" :key="`award-${awardKey(award, index)}`" class="award-item mb-4 p-3 border rounded">
      <div
        class="award-header d-flex justify-content-between align-items-center"
        role="button"
        tabindex="0"
        @click="toggleAward(awardKey(award, index))"
        @keydown.enter.prevent="toggleAward(awardKey(award, index))"
        @keydown.space.prevent="toggleAward(awardKey(award, index))"
      >
        <h6 class="mb-0 border-0 pb-0">{{ awardHeaderTitles[awardKey(award, index)] }}</h6>
        <i class="bi" :class="isAwardExpanded(awardKey(award, index)) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </div>
      <div v-if="isAwardExpanded(awardKey(award, index))" class="row my-3">
        <div class="col-md-6">
          <label class="form-label">Year</label>
          <input
            type="date"
            class="form-control"
            v-model="award.year"
            @input="emitUpdate"
          >
        </div>
        <div class="col-md-6">
          <label class="form-label">University</label>
          <input
            type="text"
            class="form-control"
            v-model="award.university"
            @input="emitUpdate"
          >
        </div>
      </div>
      <div v-if="isAwardExpanded(awardKey(award, index))" class="row">
        <div class="col-md-12 d-flex justify-content-end">
          <button type="button" class="btn btn-sm btn-outline-danger" @click="removeAward(index)">
            <i class="bi bi-x me-1"></i>Remove
          </button>
        </div>
      </div>
    </div>

    <!-- Other Experiences Section -->
    <div class="section-header d-flex justify-content-between align-items-center">
      <h5 class="section-title">Other Experiences</h5>
      <button type="button" class="btn btn-outline-primary" @click="addOtherExperience">
        <i class="bi bi-plus me-2"></i>Add Other Experience
      </button>
    </div>

      <div v-for="(experience, index) in otherExperiences" :key="`experience-${otherExperienceKey(experience, index)}`" class="experience-item mb-4 p-3 border rounded">
        <div
          class="experience-header d-flex justify-content-between align-items-center"
          role="button"
          tabindex="0"
          @click="toggleOtherExperience(otherExperienceKey(experience, index))"
          @keydown.enter.prevent="toggleOtherExperience(otherExperienceKey(experience, index))"
          @keydown.space.prevent="toggleOtherExperience(otherExperienceKey(experience, index))"
        >
          <h6 class="mb-0 border-0 pb-0">{{ otherExperienceHeaderTitles[otherExperienceKey(experience, index)] }}</h6>
          <i class="bi" :class="isOtherExperienceExpanded(otherExperienceKey(experience, index)) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
        </div>
        <div v-if="isOtherExperienceExpanded(otherExperienceKey(experience, index))" class="row my-3">
        <div class="col-md-12">
          <label class="form-label">Position</label>
          <input
            type="text"
            class="form-control"
            v-model="experience.position"
            @input="emitUpdate"
          >
        </div>
      </div>
        <div v-if="isOtherExperienceExpanded(otherExperienceKey(experience, index))" class="row mb-3">
        <div class="col-md-6">
          <label class="form-label">Start date</label>
          <input
            type="date"
            class="form-control"
            v-model="experience.startDate"
            @input="emitUpdate"
          >
        </div>
        <div class="col-md-6">
          <label class="form-label">End date</label>
          <input
            type="date"
            class="form-control"
            v-model="experience.endDate"
            @input="emitUpdate"
          >
        </div>
      </div>
        <div v-if="isOtherExperienceExpanded(otherExperienceKey(experience, index))" class="row">
          <div class="col-md-12 d-flex justify-content-end">
            <button type="button" class="btn btn-sm btn-outline-danger" @click="removeOtherExperience(index)">
              <i class="bi bi-x me-1"></i>Remove
            </button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'

export default {
  name: 'ExperiencesForm',
  props: {
    formData: {
      type: Object,
      required: true
    },
    profileData: {
      type: Object,
    }
  },
  emits: ['update'],
  setup(props, { emit }) {
    // Reactive refs for each section
    const studentsSupervised = ref([])
    const expandedStudentIds = ref([])
    const awards = ref([])
    const expandedAwardIds = ref([])
    const otherExperiences = ref([])
    const expandedOtherExperienceIds = ref([])

    const normalizeHeaderText = (value) => {
      if (typeof value !== 'string') return ''
      const cleaned = value.trim().replace(/\s+/g, ' ')
      if (!cleaned) return ''

      return cleaned
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    }

    const getYear = (value) => {
      const dateValue = typeof value === 'string' ? value.trim() : ''
      const match = dateValue.match(/^(\d{4})/)
      return match ? match[1] : ''
    }

    const studentKey = (student, index) => {
      if (!student) return `new-${index}`
      return student.id || student._localKey || `new-${index}`
    }

    const studentHeaderTitles = computed(() => {
      return studentsSupervised.value.reduce((titles, student, index) => {
        const key = studentKey(student, index)
        const studentType = normalizeHeaderText(student?.type)
        const name = normalizeHeaderText(student?.name)
        const year = getYear(student?.startDate)

        if (!studentType && !name && !year) {
          titles[key] = 'New Student'
          return titles
        }

        titles[key] = [studentType, name, year].filter(Boolean).join(', ')
        return titles
      }, {})
    })

    const awardKey = (award, index) => {
      if (!award) return `new-${index}`
      return award.id || award._localKey || `new-${index}`
    }

    const awardHeaderTitles = computed(() => {
      return awards.value.reduce((titles, award, index) => {
        const key = awardKey(award, index)
        const university = normalizeHeaderText(award?.university)
        const year = getYear(award?.year)

        if (!university && !year) {
          titles[key] = 'New Award'
          return titles
        }

        titles[key] = [university, year].filter(Boolean).join(', ')
        return titles
      }, {})
    })

    const otherExperienceKey = (experience, index) => {
      if (!experience) return `new-${index}`
      return experience.id || experience._localKey || `new-${index}`
    }

    const otherExperienceHeaderTitles = computed(() => {
      return otherExperiences.value.reduce((titles, experience, index) => {
        const key = otherExperienceKey(experience, index)
        const position = normalizeHeaderText(experience?.position)
        const year = getYear(experience?.startDate)

        if (!position && !year) {
          titles[key] = 'New Other Experience'
          return titles
        }

        titles[key] = [position, year].filter(Boolean).join(', ')
        return titles
      }, {})
    })

    // Initialize data from props
    const initializeData = () => {
      // Initialize from formData first
      if (props.formData.studentsSupervised?.length > 0) {
        studentsSupervised.value = props.formData.studentsSupervised.map(student => ({
          id: student.id || null,
          _localKey: student.id ? null : `${Date.now()}-${Math.random()}`,
          _isNew: false,
          type: student.type || '',
          name: student.name || '',
          title: student.title || '',
          university: student.university || '',
          startDate: student.startDate || '',
          endDate: student.endDate || ''
        }))
      }

      if (props.formData.awards?.length > 0) {
        awards.value = props.formData.awards.map(award => ({
          id: award.id || null,
          _localKey: award.id ? null : `${Date.now()}-${Math.random()}`,
          _isNew: false,
          year: award.year || '',
          university: award.university || ''
        }))
      }

      if (props.formData.otherExperiences?.length > 0) {
        otherExperiences.value = props.formData.otherExperiences.map(experience => ({
          id: experience.id || null,
          _localKey: experience.id ? null : `${Date.now()}-${Math.random()}`,
          _isNew: false,
          position: experience.position || '',
          startDate: experience.startDate || '',
          endDate: experience.endDate || ''
        }))
      }

      // Override with profile data if available
      if (props.profileData?.data?.personal) {
        const fellowData = props.profileData.data.personal

        if (fellowData.studentsSupervised?.length > 0) {
          studentsSupervised.value = fellowData.studentsSupervised.map(student => ({
            id: student.id || null,
            _localKey: student.id ? null : `${Date.now()}-${Math.random()}`,
            _isNew: false,
            type: student.type || '',
            name: student.name || '',
            title: student.title || '',
            university: student.university || '',
            startDate: student.startDate || '',
            endDate: student.endDate || ''
          }))
        }

        // Parse awards if it's a string
        if (fellowData.awards) {
          try {
            const parsedAwards = typeof fellowData.awards === 'string'
              ? JSON.parse(fellowData.awards)
              : fellowData.awards

            if (Array.isArray(parsedAwards) && parsedAwards.length > 0) {
              awards.value = parsedAwards.map(award => ({
                id: award.id || null,
                _localKey: award.id ? null : `${Date.now()}-${Math.random()}`,
                _isNew: false,
                year: award.year || '',
                university: award.university || ''
              }))
            }
          } catch (e) {
            console.warn('Error parsing awards:', e)
          }
        }

        if (fellowData.otherExperiences?.length > 0) {
          otherExperiences.value = fellowData.otherExperiences.map(experience => ({
            id: experience.id || null,
            _localKey: experience.id ? null : `${Date.now()}-${Math.random()}`,
            _isNew: false,
            position: experience.position || '',
            startDate: experience.startDate || '',
            endDate: experience.endDate || ''
          }))
        }
      }

      expandedStudentIds.value = studentsSupervised.value
        .map((student, index) => (student._isNew ? studentKey(student, index) : null))
        .filter(Boolean)
      expandedAwardIds.value = awards.value
        .map((award, index) => (award._isNew ? awardKey(award, index) : null))
        .filter(Boolean)
      expandedOtherExperienceIds.value = otherExperiences.value
        .map((experience, index) => (experience._isNew ? otherExperienceKey(experience, index) : null))
        .filter(Boolean)
    }

    // Emit current data to parent
    const emitUpdate = () => {
      const data = {
        studentsSupervised: studentsSupervised.value,
        awards: awards.value,
        otherExperiences: otherExperiences.value
      }

      emit('update', data)
    }

    // Add methods
    const addStudent = () => {
      const newStudent = {
        id: null,
        _localKey: `${Date.now()}-${Math.random()}`,
        _isNew: true,
        type: '',
        name: '',
        title: '',
        university: '',
        startDate: '',
        endDate: ''
      }

      studentsSupervised.value.push(newStudent)
      const key = studentKey(newStudent, studentsSupervised.value.length - 1)
      if (key && !expandedStudentIds.value.includes(key)) {
        expandedStudentIds.value.push(key)
      }
      emitUpdate()
    }

    const removeStudent = (index) => {
      const removed = studentsSupervised.value[index]
      studentsSupervised.value.splice(index, 1)
      const removedKey = studentKey(removed, index)
      expandedStudentIds.value = expandedStudentIds.value.filter((id) => id !== removedKey)
      emitUpdate()
    }

    const toggleStudent = (key) => {
      if (!key) return

      if (expandedStudentIds.value.includes(key)) {
        expandedStudentIds.value = expandedStudentIds.value.filter((id) => id !== key)
      } else {
        expandedStudentIds.value.push(key)
      }
    }

    const isStudentExpanded = (key) => expandedStudentIds.value.includes(key)

    const addAward = () => {
      const newAward = {
        id: null,
        _localKey: `${Date.now()}-${Math.random()}`,
        _isNew: true,
        year: '',
        university: ''
      }

      awards.value.push(newAward)
      const key = awardKey(newAward, awards.value.length - 1)
      if (key && !expandedAwardIds.value.includes(key)) {
        expandedAwardIds.value.push(key)
      }
      emitUpdate()
    }

    const removeAward = (index) => {
      const removed = awards.value[index]
      awards.value.splice(index, 1)
      const removedKey = awardKey(removed, index)
      expandedAwardIds.value = expandedAwardIds.value.filter((id) => id !== removedKey)
      emitUpdate()
    }

    const toggleAward = (key) => {
      if (!key) return

      if (expandedAwardIds.value.includes(key)) {
        expandedAwardIds.value = expandedAwardIds.value.filter((id) => id !== key)
      } else {
        expandedAwardIds.value.push(key)
      }
    }

    const isAwardExpanded = (key) => expandedAwardIds.value.includes(key)

    const addOtherExperience = () => {
      const newExperience = {
        id: null,
        _localKey: `${Date.now()}-${Math.random()}`,
        _isNew: true,
        position: '',
        startDate: '',
        endDate: ''
      }

      otherExperiences.value.push(newExperience)
      const key = otherExperienceKey(newExperience, otherExperiences.value.length - 1)
      if (key && !expandedOtherExperienceIds.value.includes(key)) {
        expandedOtherExperienceIds.value.push(key)
      }
      emitUpdate()
    }

    const removeOtherExperience = (index) => {
      const removed = otherExperiences.value[index]
      otherExperiences.value.splice(index, 1)
      const removedKey = otherExperienceKey(removed, index)
      expandedOtherExperienceIds.value = expandedOtherExperienceIds.value.filter((id) => id !== removedKey)
      emitUpdate()
    }

    const toggleOtherExperience = (key) => {
      if (!key) return

      if (expandedOtherExperienceIds.value.includes(key)) {
        expandedOtherExperienceIds.value = expandedOtherExperienceIds.value.filter((id) => id !== key)
      } else {
        expandedOtherExperienceIds.value.push(key)
      }
    }

    const isOtherExperienceExpanded = (key) => expandedOtherExperienceIds.value.includes(key)

    // Initialize on mount
    onMounted(() => {
      initializeData()
    })

    return {
      studentsSupervised,
      studentHeaderTitles,
      studentKey,
      toggleStudent,
      isStudentExpanded,
      awards,
      awardHeaderTitles,
      awardKey,
      toggleAward,
      isAwardExpanded,
      otherExperiences,
      otherExperienceHeaderTitles,
      otherExperienceKey,
      toggleOtherExperience,
      isOtherExperienceExpanded,
      addStudent,
      removeStudent,
      addAward,
      removeAward,
      addOtherExperience,
      removeOtherExperience,
      emitUpdate
    }
  }
}
</script>

<style scoped>
.form-step {
  min-height: 400px;
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.form-control,
.form-select {
  border-radius: 6px;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
}

.form-control:focus,
.form-select:focus {
  border-color: #17a2b8;
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.25);
}

.student-item,
.award-item,
.experience-item {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.student-header {
  cursor: pointer;
  user-select: none;
}

.award-header {
  cursor: pointer;
  user-select: none;
}

h6 {
  color: #495057;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 0.5rem;
}

.btn-outline-danger {
  border-color: #dc3545;
  color: #dc3545;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  color: white;
}

.section-header {
  margin: 2rem 0 1.5rem 0;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #17a2b8;
}

.section-title {
  color: #17a2b8;
  font-weight: 600;
  font-size: 1.1rem;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
